import IconNameEnum from "constants/IconNameEnum";
import React from "react";
import BaseIcon from "./BaseIcon";
import BaseTruncatedText from "./BaseTruncatedText";

interface IProps {
    icon?: IconNameEnum;
    label?: string;
    containerClassName?: string;
    iconClassName?: string;
    labelClassName?: string;
    color?: "default" | "white";
    badge?: string | number;
    onClick?: () => void;
}

class BaseLabel extends React.Component<IProps> {
    public render(): JSX.Element {
        const { label, icon, color, badge, containerClassName, iconClassName, labelClassName, onClick } = this.props;

        return (
            <div className={[containerClassName, "media"].join(" ")} onClick={onClick}>
                {icon && (
                    <BaseIcon
                        icon={icon}
                        color={color}
                        badge={badge}
                        className={[label ? "mr-2" : "", iconClassName].join(" ")}
                    />
                )}
                {label && (
                    <BaseTruncatedText text={label} className={["align-self-center mb-0", labelClassName].join(" ")} />
                )}
            </div>
        );
    }
}

export { BaseLabel as Unconnected };
export default BaseLabel;
